import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
import { WinSquareMarkesAnimations } from "../WinLines/WinSquaresMarkersAnimations";
import { WinLinesAnimationParams } from "../WinLines/GenericWinLinesAnimation";
export class BurningFruits100_2Screen extends SlotGameType1_2Screen {
    protected override helpFactory: IHelpFactory = new BurningFruits100_HelpFactory();
    protected override panelFactory: IPanelFactory = new BurningFruits100_PanelFactory();
    //LED COLOR
    protected override ColorLed: string = "250,0,0\n";
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "BurningFruits100");
        this.spinnableReelsParams.topBorderWidth = 0;
        this.spinnableReelsParams.bottomBorderWidth = 0;
    }
    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "white",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }
}

//Help Colorized
class BurningFruits100_HelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new BurningFruits100_Help(params);
    }
}

class BurningFruits100_Help extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}

//Panel Colorized
class BurningFruits100_PanelFactory implements IPanelFactory {
    public CreateNewPanel(params: PanelParams): Panel {
        return new BurningFruits100_Panel(params);
    }
}

class BurningFruits100_Panel extends Panel {
    protected override ButtonBackground(): ButtonColors {
        let color: ButtonColors = {
            backgroundButtonColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor: "linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
        };
        return color;
    }
}